import type { SalesforceDocument } from "../types";
import { createDateColumn, createStringColumn } from "./columnHelpers";
import { createLinkColumn } from "./linkColumnHelper";

const namespace = "salesforce";

export const salesforceColumns = [
    createStringColumn<SalesforceDocument>({
        namespace,
        field: "metadata.Account Name",
        header: "Customer Name",
    }),
    createStringColumn<SalesforceDocument>({
        namespace,
        field: "metadata.Subject",
        header: "Subject",
    }),
    createStringColumn<SalesforceDocument>({
        namespace,
        field: "metadata.Case Number",
        header: "Case Number",
    }),
    createStringColumn<SalesforceDocument>({
        namespace,
        field: "metadata.Case ID",
        header: "Case ID",
    }),
    createStringColumn<SalesforceDocument>({
        namespace,
        field: "metadata.Case Owner",
        header: "Case Owner",
    }),
    createDateColumn<SalesforceDocument>({
        namespace,
        field: "metadata.Date/Time Opened",
        header: "Date/Time Opened",
    }),
    createStringColumn<SalesforceDocument>({
        namespace,
        field: "metadata.Machine No",
        header: "Machine No",
    }),
    createStringColumn<SalesforceDocument>({
        namespace,
        field: "metadata.Product Type",
        header: "Product Type",
    }),
    createLinkColumn<SalesforceDocument>({
        namespace,
        field: "metadata.source",
        header: "Source",
    }),
];
